import { CALCULATIONS_STEPS } from './steps';
import { CALCULATIONS_PAGE } from './page';
import { CALCULATIONS_TABLE } from './table';
import { CALCULATION_ACTIONS } from './actions';
import { CALCULATION_DETAILS_DRAWER } from './calculationDetailsDrawer';
import { CALCULATION_LEGISLATION } from './legislation';
export const CALCULATIONS_TRANSLATION = {
    ...CALCULATIONS_PAGE,
    ...CALCULATIONS_STEPS,
    ...CALCULATIONS_TABLE,
    ...CALCULATION_ACTIONS,
    ...CALCULATION_DETAILS_DRAWER,
    ...CALCULATION_LEGISLATION
};
